import { render, staticRenderFns } from "./deleteDetail.vue?vue&type=template&id=5ca50d80&scoped=true&"
import script from "./deleteDetail.vue?vue&type=script&lang=js&"
export * from "./deleteDetail.vue?vue&type=script&lang=js&"
import style0 from "./deleteDetail.vue?vue&type=style&index=0&id=5ca50d80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca50d80",
  null
  
)

export default component.exports